import { Components, Theme } from '@mui/material';

const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(theme.spacingSizes.lg),
      justifyContent: 'space-between',
    }),
  },
};

export default MuiDialogActions;
